import {
  authTypes,
  registerTypes,
  resetPasswordTypes,
  changePasswordTypes,
} from './types';

const authActions = {
  
  authReset: () => ({ type: authTypes.RESET }),
  authRequest: () => ({ type: authTypes.REQUEST }),

  sendingPolicy: (payload) => ({
    type: authTypes.SENDING_POLICY,
    payload
  }),

  registerSuccess: (payload: string) => ({
    type: registerTypes.SUCCESS,
    payload
  }),
  registerFailed: payload => ({
    type: registerTypes.FAILED,
    payload
  }),

  resetPasswordSuccess: () => ({
    type: resetPasswordTypes.SUCCESS
  }),
  resetPasswordFailed: errorMessage => ({
    type: resetPasswordTypes.FAILED,
    payload: errorMessage
  }),
  
  changePasswordSuccess: () => ({
    type: changePasswordTypes.SUCCESS
  }),
  changePasswordFailed: errorMessage => ({
    type: changePasswordTypes.FAILED,
    payload: errorMessage
  }),

};

export default authActions;
